<!--
 * @Description:
 * @Autor: gxd
 * @Date: 2020-12-01 19:09:52
 * @LastEditors: gxd
 * @LastEditTime: 2021-01-07 16:40:20
 * ---上传审核组件---
-->
<template>
  <div>
    <div class="invitation-upload">
      <div class="invitation-upload-top">
        <div class="invitation-upload-top-title">{{this.uploadStatus.localTitle}}</div>
        <div class="invitation-upload-top-cont">{{this.uploadStatus.localDescription}}</div>
      </div>
      <div :class="[isAlert?'invitation-upload-content-alert-height':'', 'invitation-upload-content']">
        <div class="invitation-upload-left" @click="showPreview()">
          <img src="../assets/images/v4.0/example.png" alt="示例图片">
        </div>
        <div class="invitation-upload-right" :class="[uploadStatus.localBlackBg ? 'invitation-upload-right-black' : '']">
          <img class="invitation-upload-right-image" v-if="uploadStatus.upload_url" :src="uploadStatus.upload_url" alt="图片">
          <div :class="['invitation-upload-right-content', uploadStatus.localBlackBg?'invitation-upload-right-content-mask':'']" @click="handleUploadImgClick()">
            <!-- 可上传图片 -->
            <div v-if="uploadStatus.upload && (isFinishing && (uploadStatus.review_status === 0))" class="van-uploader" ref="vanUploader">
              <div class="van-uploader-box">
                <div v-if="uploadStatus.localImage != ''" class="invitation-upload-result-img">
                  <img :src="uploadStatus.localImage" alt="可上传">
                </div>
                <div :class="['invitation-upload-result-status', uploadStatus.localBlackBg ? 'invitation-upload-result-status-white' : '']">{{uploadStatus.localMsg}}</div>
                <div v-if="(uploadStatus.review_status==2) || (uploadStatus.review_status==-10001)" :class="['invitation-upload-result-status', uploadStatus.localBlackBg ? 'invitation-upload-result-status-white' : '']">点击重新上传</div>
              </div>
            </div>
            <!-- 可上传图片 -->
            <van-uploader v-else-if="uploadStatus.upload" :disabled='isFinishing && (uploadStatus.review_status === 0)' class="van-uploader" ref="vanUploader" :after-read="afterRead" :result-type="fileType">
              <div class="van-uploader-box">
                <div v-if="uploadStatus.localImage != ''" class="invitation-upload-result-img">
                  <img :src="uploadStatus.localImage" alt="可上传">
                </div>
                <div :class="['invitation-upload-result-status', uploadStatus.localBlackBg ? 'invitation-upload-result-status-white' : '']">{{uploadStatus.localMsg}}</div>
                <div v-if="(uploadStatus.review_status==2) || (uploadStatus.review_status==-10001)" :class="['invitation-upload-result-status', uploadStatus.localBlackBg ? 'invitation-upload-result-status-white' : '']">点击重新上传</div>
              </div>
            </van-uploader>
            <!-- 不可上传图片 -->
            <div class="invitation-upload-result" v-else>
              <div class="van-uploader-box">
                <div v-if="uploadStatus.localImage != ''" class="invitation-upload-result-img">
                  <img :src="uploadStatus.localImage" alt="不可上传">
                </div>
                <div :class="['invitation-upload-result-status', uploadStatus.localBlackBg ? 'invitation-upload-result-status-white' : '']">{{uploadStatus.localMsg}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <slot></slot>
    </div>
    <!-- 【弹框】图片预览 -->
    <van-popup class="example-preview-popup" get-container="body" v-model="isShowPreview" @click="isShowPreview=false">
      <img @click="isShowPreview=false" class="close-example-preview" src="../assets/images/v4.0/close-preview.png" alt="">
      <img src="../assets/images/v4.0/example.png" alt="示例图片">
    </van-popup>
    <!-- 【弹框】上传图片确认 -->
    <uploadConfirm :isShow="isShowUploadConfirm" :imgUrl="selectedFileUrl" @uploadCancel="uploadCancel" @uploadConfirm="uploadConfirm"></uploadConfirm>
  </div>
</template>
<script>

import { mapState } from 'vuex'
import uploadConfirm from '../components/UploadConfirm' // 上传截图确认弹框

export default {
  name: 'ReviewUpload',
  components: { uploadConfirm },
  computed: mapState(['uploadStatus', 'currentWeekIndex', 'isFinishing']),
  data () {
    return {
      isShowPreview: false,
      fileType: 'file',
      isShowReviewCalendar: true,
      isShowBottom: true,
      isShowUploadConfirm: false, // 展示上传图片确认弹框
      selectedFile: '',
      selectedFileUrl: '',
      isRequesting: false
    }
  },
  props: {
    isAlert: {
      type: Boolean,
      default: false
    }
  },
  created () {
    console.log('ReviewUpload created---', this.isAlert)
  },
  watch: {
    currentWeekIndex (val) {
      console.log('currentWeekIndex changeto----', val)
    }
  },
  methods: {
    // 上传确认弹框-确认
    uploadConfirm () {
      this.$xesLogger.clickMsg({
        params: {
          elementname: '截图审核',
          element_action: 'click',
          element_value: '截图审核-二次确认弹框-确定按钮-点击'
        }
      })
      this.uploadFile(this.selectedFile)
    },
    // 上传确认弹框-取消
    uploadCancel () {
      this.$xesLogger.clickMsg({
        params: {
          elementname: '截图审核',
          element_action: 'click',
          element_value: '截图审核-二次确认弹框-重新选图按钮-点击'
        }
      })
      this.isShowUploadConfirm = false
      this.$refs.vanUploader.$refs.input.click()
    },
    // 上传文件
    uploadFile (file) {
      // 此时可以自行将文件上传至服务器
      if (this.isRequesting) {
        return
      }
      console.log('back===', file)
      this.$toast.loading({
        forbidClick: true,
        message: '上传中...',
        duration: 0
      })
      this.isRequesting = true
      // 计算上传的目标周
      let dateTime = new Date()
      if (this.isAlert) {
        dateTime = dateTime.setDate(dateTime.getDate() - (this.currentWeekIndex - this.uploadStatus.current_week) * 7)
      }
      dateTime = new Date(dateTime)
      const strNextWeek = Date.parse(dateTime) / 1000
      console.log('strNextWeek----', strNextWeek)
      this.$api.uploadImageForReview(file, strNextWeek).then(res => {
        this.$toast.clear()
        console.log('===上传审核图片=====', res)
        if (res.data.code === 0) {
          // 获取审核状态，刷新图片
          this.$toast('上传成功，请耐心等待审核')
          const statusTemp = {}
          statusTemp.upload = false
          statusTemp.review_status = -3 // 前端设置的状态，-2，未操作（请求中）；-3，审核中
          statusTemp.localImage = ''
          statusTemp.localMsg = '审核中'
          statusTemp.localBlackBg = true
          statusTemp.localTitle = '审核中，请耐心等待'
          statusTemp.localDescription = '审核人员将在2个工作日内完成审核并以推送消息的形式将审核结果发给您'
          statusTemp.week_start = this.uploadStatus.week_start
          statusTemp.week_end = this.uploadStatus.week_end
          statusTemp.deadline = this.uploadStatus.deadline
          statusTemp.current_week = this.uploadStatus.current_week
          this.$store.dispatch('storeUploadStatus', statusTemp)
          this.isShowUploadConfirm = false
          this.$emit('getReviewStatus')
        } else {
          // 上传失败
          const statusTemp = {}
          statusTemp.upload = true
          statusTemp.review_status = -10001 // 前端设置的状态，-10001：上传失败
          statusTemp.localImage = ''
          statusTemp.localMsg = '上传失败'
          statusTemp.localBlackBg = false
          statusTemp.localTitle = '请上传朋友圈截图'
          statusTemp.localDescription = '上传朋友圈分享海报截图，审核成功后获得1次兑换次数'
          if (this.uploadStatus) {
            statusTemp.week_start = this.uploadStatus.week_start ? this.uploadStatus.week_start : ''
            statusTemp.week_end = this.uploadStatus.week_end ? this.uploadStatus.week_end : ''
            statusTemp.deadline = this.uploadStatus.deadline ? this.uploadStatus.deadline : ''
            statusTemp.current_week = this.uploadStatus.current_week ? this.uploadStatus.current_week : ''
          }
          this.$store.dispatch('storeUploadStatus', statusTemp)
          this.isShowUploadConfirm = false
          this.$emit('getReviewStatus')
          if (res.data.msg) {
            this.$toast({
              message: res.data.msg,
              duration: 2000
            })
          } else {
            this.$toast('上传失败')
          }
          this.$xesLogger.clickMsg({
            params: {
              elementname: '截图审核',
              element_action: 'show',
              element_value: '图片选择-进行弹框确认-上传失败-Toast提示',
              type: res.data.code
            }
          })
        }
        setTimeout(() => {
          this.isRequesting = false
        }, 600)
      }).catch((e) => {
        this.$toast.clear()
        console.log(e)
        this.$toast('上传失败')
        this.isShowUploadConfirm = false
        this.$emit('getReviewStatus')
        setTimeout(() => {
          this.isRequesting = false
        }, 600)
        this.$xesLogger.clickMsg({
          params: {
            elementname: '截图审核',
            element_action: 'show',
            element_value: '图片选择-进行弹框确认-上传失败-Toast提示',
            type: 'error-log',
            method: 'uploadImageForReview' + strNextWeek
          }
        })
      })
    },
    // 读取到文件内容
    afterRead (file) {
      this.isShowUploadConfirm = true
      this.selectedFile = file.file
      this.selectedFileUrl = URL.createObjectURL(this.selectedFile)
      this.$xesLogger.clickMsg({
        params: {
          elementname: '截图审核',
          element_action: 'click',
          element_value: '图片选择-进行弹框确认'
        }
      })
    },
    // 展示预览
    showPreview () {
      this.isShowPreview = !this.isShowPreview
    },
    // 点击上传图片
    handleUploadImgClick () {
      if (this.isFinishing && (this.uploadStatus.review_status === 0)) {
        this.$toast('活动已结束')
        this.$xesLogger.clickMsg({
          params: {
            elementname: '首页海报',
            element_action: 'click',
            element_value: '截图审核-提示-活动已结束-handleUploadImgClick'
          }
        })
      }
      if (!this.isAlert) {
        let message = '待上传状态“+”点击'
        // review_status: 0审核中、1审核通过、2、审核失败
        if ((this.uploadStatus.review_status === 0) && (this.uploadStatus.upload_url !== '')) {
          message = '审核中+”点击“'
        } else if (this.uploadStatus.review_status === 1) {
          message = '审核通过+”点击“'
        } else if (this.uploadStatus.review_status === 2) {
          message = '审核不通过“+”点击'
        } else if (this.uploadStatus.review_status === -10001) {
          message = '上传失败“+”点击'
        }
        this.$xesLogger.clickMsg({
          params: {
            elementname: '截图审核',
            element_action: 'click',
            element_value: message
          }
        })
      } else {
        let name = '日历页上传弹窗'
        let message = '日历页-弹窗-点击-' + this.uploadStatus.review_status
        if (this.currentWeekIndex === this.uploadStatus.current_week) {
          name = '本周弹窗'
          if (this.uploadStatus.review_status === -1) {
            message = '日历页-本周弹窗-待上传-按钮-点击'
          } else if (this.uploadStatus.review_status === 2) {
            message = '日历页-本周弹窗-审核不通过-按钮-点击'
          }
        } else {
          name = '补卡弹窗'
          message = '日历页-补卡弹窗-审核不通过-按钮-点击'
        }
        this.$xesLogger.clickMsg({
          params: {
            elementname: name,
            element_action: 'click',
            element_value: message
          }
        })
      }
    }
  }
}
</script>

<style lang='less' scoped>
// ## 上传截图
.invitation-upload {
  margin: 15px 15px 5px 10px;
  text-align: left;
  background: #fff;

  .invitation-upload-top {
    margin-left: 10px;
    margin-bottom: 6.5px;

    .invitation-upload-top-title {
      margin-bottom: 3px;
      font-size: 15px;
      font-weight: 600;
      color: #e02727;
    }

    .invitation-upload-top-cont {
      font-size: 11px;
      font-weight: 400;
      color: #666;
    }
  }

  .invitation-upload-content-alert-height {
    height: 185px !important;
  }

  .invitation-upload-content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
    height: 210px;
    padding-right: 10px;

    .invitation-upload-left {
      display: flex;
      justify-content: center;
      align-items: flex-end;
      width: 52%;
      height: 100%;

      & > img {
        width: 100%;
        max-width: 100%;
        height: auto;
        max-height: 100%;
      }
    }

    .invitation-upload-right {
      position: relative;
      // margin-left: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 46%;
      height: 98%;
      overflow: hidden;
      background-color: #efefef;

      .invitation-upload-right-image {
        width: auto;
        max-width: 100%;
        height: auto;
        max-height: 100%;
      }

      .invitation-upload-right-content-mask {
        background: #efefef;
      }

      .invitation-upload-right-content {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        font-size: 14px;
        color: black;

        .van-uploader {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 100%;

          & .van-uploader-box {
            display: flex;
            flex-direction: column;
            flex-wrap: wrap;
            justify-content: center;
            align-items: center;
            width: 35vw;
            height: 40vw;
          }
        }

        .invitation-upload-result-img {
          width: 100%;
          height: 40px;
          margin-bottom: 15px;
          text-align: center;

          img {
            width: auto;
            max-width: 100%;
            height: auto;
            max-height: 100%;
          }
        }

        .invitation-upload-result-status {
          margin-top: 5px;
          font-size: 14px;
          font-weight: 500;
          line-height: 100%;
          text-align: center;
          color: #666;
        }

        .invitation-upload-result-status-white {
          font-size: 14px;
          color: #666;
        }
      }
    }

    .invitation-upload-right-white {
      background-color: #efefef;
    }

    .invitation-upload-right-black {
      background-color: #666;
    }
  }
}

.example-preview-popup {
  width: 90vw;
  border-radius: 12px;

  .close-example-preview {
    position: absolute;
    top: 5px;
    right: 5px;
    width: 24px;
    height: 24px;
  }
}
</style>
